<template>
    <section id="syarat-pengajuan" class="p-4 mt-4">
      <div>
        <p class="product-sub-title">
          Syarat Pengajuan Pembiayaan Kendaraan
        </p>
        <p class="product-description-blue">
          Ada beberapa dokumen sebagai syarat yang harus dipenuhi sebelum
          mengajukan Pembiayaan Pemilikan Kendaraan.
        </p>
      </div>
      <div>
        <p class="product-description-blue font-weight-bold">
          Pembiayaan Perorangan:
        </p>
        <ul
          style="list-style-type: circle; list-style-position: inside"
          class="pl-0"
        >
          <li class="product-description-blue">
            Fotocopy KTP pemohon & suami / istri / penjamin
          </li>
          <li class="product-description-blue">
            Fotocopy Kartu Keluarga
          </li>
          <li class="product-description-blue">Fotocopy Surat Nikah.</li>
          <li class="product-description-blue">
            Mutasi Rekening pemohon & pasangan 3 bulan terakhir
          </li>
        </ul>
        <p class="product-description-blue">Jika Pegawai:</p>
        <ul
          style="list-style-type: circle; list-style-position: inside"
          class="pl-0"
        >
          <li class="product-description-blue">
            Surat keterangan karyawan tetap
          </li>
          <li class="product-description-blue">
            Slip gaji 3 bulan terakhir
          </li>
        </ul>
        <p class="product-description-blue">Jika Wirausaha:</p>
        <ul
          style="list-style-type: circle; list-style-position: inside"
          class="pl-0"
        >
          <li class="product-description-blue">
            Surat keterangan usaha dari pemerintah setempat
          </li>
          <li class="product-description-blue">
            Laporan keuangan 3 bulan terakhir
          </li>
        </ul>
        <p class="product-description-blue font-weight-bold">
          Pembiayaan Perusahaan:
        </p>
        <ul
          style="list-style-type: circle; list-style-position: inside"
          class="pl-0"
        >
          <li class="product-description-blue">
            Fotocopy akte pendirian & akta perubahan terakhir beserta SK
            Kemenkumham
          </li>
          <li class="product-description-blue">Fotocopy NPWP</li>
          <li class="product-description-blue">Fotocopy SIUP</li>
          <li class="product-description-blue">
            Fotocopy Surat keterangan Domisili
          </li>
          <li class="product-description-blue">Fotocopy NIB</li>
          <li class="product-description-blue">
            Fotocopy Rek. Koran 3 bulan terakhir
          </li>
          <li class="product-description-blue">
            Fotocopy laporan keuangan audited 3 bulan terakhir
          </li>
          <li class="product-description-blue">
            Fotocopy KTP pengurus (Direksi & Komisaris)
          </li>
        </ul>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: "SyaratPengajuan"
  };
  </script>
  
<style scoped>
.product-description-blue {
  font-size: 20px;
  color: #13346c;
  font-weight: 400;
  margin: 0;
  padding: 0;
}
.product-sub-title {
  font-size: 20px;
  font-weight: 600;
  color: #13346c;
  text-transform: capitalize;
}
</style>


// WEBPACK FOOTER //
// src/components/SyaratPengajuan.vue